export default __webpack_public_path__ + "static/media/whiteCloseIcon.218fff07.svg";